"use client"

import styled from "@emotion/styled"
import { IconButton } from "@mui/material"
import Image from "next/image"
import { useState } from "react"
import { getUmbracoMediaUrl } from "utils"
import { Desktop } from "../common/bit/MediaQueries"

const StyledDiv = styled.div`
  width: 100%;
  height: 100%;
`

const StyledImageContainer = styled.div<{ hasBorder?: boolean }>`
  position: relative;
  height: 100%;
  width: 100%;
  border: ${(p) => (p.hasBorder ? "2px solid black" : "none")};
`

const StyledBarDiv = styled.div<{ $length: number }>`
  display: grid;
  grid-template-columns: repeat(${(p) => p.$length}, 1fr);
  position: absolute;
  top: 10px;
  gap: 10px;
  height: fit-content;
  width: 100%;
  padding-left: 10px;
  padding-right: 10px;
`

const StyledBarItem = styled.div<{ $filled: boolean }>`
  background-color: ${(p) =>
    p.$filled ? "white" : "rgba(255, 255, 255, 0.5)"};
  height: 6px;
`

const StyledNavigationDiv = styled.div<{ $centerButton: boolean }>`
  position: absolute;
  bottom: 0;
  display: flex;
  width: 100%;
  padding-left: 10px;
  padding-right: 10px;
  padding-bottom: 15px;
  justify-content: space-between;
  top: ${(p) => (p.$centerButton ? "50%" : "unset")};
  button {
    width: 30px;
    height: 30px;
    background-color: white;
    border-radius: 50%;
    &:hover {
      background-color: white;
    }
    &:disabled {
      background-color: gray;
    }
  }
`

type Props = {
  data: any
  centerButton?: boolean
  hasBorder?: boolean
}

const StaticStory = ({ data, centerButton = false, hasBorder }: Props) => {
  const [activeIndex, setActiveIndex] = useState(0)
  const length = data.length
  const lengthArray = Array.from({ length }, (_, index) => index)
  return (
    <StyledDiv>
      <StyledImageContainer hasBorder={hasBorder}>
        <Image
          src={getUmbracoMediaUrl(data[activeIndex].url)}
          alt={""}
          fill
          style={{ objectFit: "cover" }}
        />
        <Desktop>
          <StyledBarDiv $length={length}>
            {lengthArray.map((item) => (
              <StyledBarItem key={item} $filled={item <= activeIndex} />
            ))}
          </StyledBarDiv>
        </Desktop>
        <StyledNavigationDiv $centerButton={centerButton}>
          <IconButton
            style={{ transform: "rotate(180deg)" }}
            disabled={activeIndex === 0}
            onClick={() => setActiveIndex((prev) => prev - 1)}
          ></IconButton>
          <IconButton
            disabled={activeIndex === data.length - 1}
            onClick={() => setActiveIndex((prev) => prev + 1)}
          ></IconButton>
        </StyledNavigationDiv>
      </StyledImageContainer>
    </StyledDiv>
  )
}

export default StaticStory
